import { render, staticRenderFns } from "./table-search.vue?vue&type=template&id=45c3c635"
import script from "./table-search.vue?vue&type=script&lang=js"
export * from "./table-search.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports